<template>
  <section class="content-tasks">
    <div class="content-tasks-itens">
      <Breadcrumb :links="links"/>
      <div class="content-tasks-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
            <a @click="routerPage()" class="content--card-register" style="min-height: 267px">
              <img class="img-fluid" src="@/assets/img/image-plus.png" alt="image plus" title="image plus"/>
            </a>
          </div>
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="music in musics.data" :key="music.id">
            <CardMusic :music="music"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CardMusic from '@/views/Meditation/pages/ListMusics/components/CardMusic';
import Breadcrumb from '@/components/breadcrumb/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Meditação',
          routerName: 'Meditation'
        },
        {
          name: 'Músicas',
          routerName: 'ListMusics'
        },
      ],
    }
  },
  computed: {
    ...mapGetters('Meditation', ['musics'])
  },
  components: {
    CardMusic,
    Breadcrumb,
  },
  methods: {
    ...mapActions('Meditation', ['consultMusics']),
    routerPage(){
      this.$router.push({
        name: 'RegisterMusic',
      })
    }
  },
  async mounted() {
    await this.consultMusics();
  }
}
</script>

<style lang="scss">
</style>
